<template>
    <div v-show="logueado" id="historial" class="container">    
        <div id="filtros" class="separador contenido bg-white br-2-blue mt-4 mb-4">
            <h2 class="text-center">Estado de Cuenta</h2>
            <div class="container-flex">
                <div class="column">
                    <div class="form-group col-md-12">
                        <label>Fecha Inicio</label>
                        <div>
                            <input class="form-control col-lg-12" type="date" v-model="filtro.fecha_desde" name="fecha_desde" />
                        </div>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Fecha Fin</label>
                        <div>
                            <input class="form-control col-lg-12" type="date" v-model="filtro.fecha_hasta" name="fechafinal" />
                        </div>
                    </div>
                </div>
                <div class="column">
                    <div class="form-group col-md-12">
                        <label>Estado</label>
                        <select class="form-control" name="estado" v-model="filtro.estado_conciliacion_id">
                            <option value="">Seleccione ...</option>
                            <option 
                                v-for="estado in estadosConciliacion"
                                :value="estado.id"
                                v-bind:key="estado.id"
                                >{{ estado.nombre }}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-12">
                        <label>Destinatario</label>
                        <div>
                            <select class="form-control" name="estado" v-model="filtro.destinatario_id">
                                <option value="">Seleccione ...</option>
                                <option v-for="destinatario in destinatarios" :value="destinatario.id" v-bind:key="destinatario.id">{{ destinatario.nombre_completo }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-group col-md-12 text-right pr-38">
                <button class="btn btn-blue" @click="busqueda()"><b-icon icon="search" aria-hidden="true"></b-icon> Buscar</button>
            </div>
        </div>
        <div id="listar" class="separador contenido bg-white br-2-blue mt-3 mb-4">
            <div class="panel panel-default">
                <div class="wrapper mt-2">
                    <form class="form ng-valid">
                        <div class="row mb-3" v-if="preliquidaciones.length > 0">
                            <div class="col-md-4 col-sm-4 col-xs-4 col-lg-3">
                                <a class="btn btn-blue" @click="exportarExcel()" role="button" href="#"><b-icon icon="cloud-arrow-down" aria-hidden="true"></b-icon>&nbsp;{{ titulo_exportar }}</a>
                            </div>
                            <div class="form-row justify-content-center col-sm-12 col-md-4 col-lg-5 text-center">
                                <label class="col-md-5 col-lg-2">Registro</label>
                                <div>
                                    <select class="form-control" name="pageSize" v-validate="'required'" @change="changePage()" :class="{ 'is-invalid': submitted && errors.has('pageSize') }" v-model="filtro.itemsPerPage">
                                        <option selected="selected" value="10">10</option>
                                        <option value="20">20</option>
                                        <option value="50">50</option>
                                        <option value="100">100</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4 col-sm-12 col-xs-12 input-buscar">
                                <input
                                    type="text"
                                    class="w-full app-input-group__m-t-xs form-control col-sm-4 col-md-6 col-lg-6 col-sm-5"
                                    v-on:keyup="changePage"
                                    placeholder="Buscar"
                                    v-model="filtro.busqueda"
                                />
                            </div>
                        </div>
                    </form>
                </div>
                <div class="row" v-if="totales.length > 0" style="margin-left: -8px !important;">
                    <div class="col-md-4 row-column">
                        <label class="font-weight-bold mb-0">Solicitudes Pendientes por pago</label>
                        <div>Valor:&nbsp;{{totales[0].pendiente_por_pago | currencyFloat}}</div>
                        <div>Valor moneda local:&nbsp;{{totales[0].pendiente_por_pago_x_trm | currencyFloat}}</div>
                    </div>
                    <div class="col-md-4 row-column">
                        <label class="font-weight-bold mb-0">Solicitudes Pagadas</label>
                        <div>Valor:&nbsp;{{totales[0].pagada | currencyFloat}}</div>
                        <div>Valor moneda local:&nbsp;{{totales[0].pagada_x_trm | currencyFloat}}</div>
                    </div>
                    <div class="col-md-4 row-column">
                        <label class="font-weight-bold mb-0">Solicitudes Conciliadas</label>
                        <div>Valor:&nbsp;{{totales[0].conciliada | currencyFloat}}</div>
                        <div>Valor moneda local:&nbsp;{{totales[0].conciliada_x_trm | currencyFloat}}</div>
                    </div>                          
                </div>
                <div class="table-responsive app-table p-1">
                    <table class="table table-striped b-t table-color" id="my-table">
                        <thead>
                            <tr>
                                <th>Id</th>
                                <th>Habws</th>
                                <th>Estado solicitud</th>
                                <th>Destinatario</th>
                                <th>Valor total solicitud</th>
                                <th>Valor moneda local</th>
                                <th>Imprimir</th>    
                            </tr>
                        </thead>
                        <tbody v-if="!cargando">
                            <tr 
                                v-for="preliquidacion in preliquidaciones"
                                v-bind:key="preliquidacion.id">
                                <td>{{preliquidacion.id}}</td>
                                <td>{{preliquidacion.hawbs}}</td>
                                <td>{{preliquidacion.estado_conciliacion_preliq}}</td>
                                <td>{{preliquidacion.nombre_destinatario}}</td>
                                <td>{{preliquidacion.valor_cliente | currency}}</td>
                                <td>{{preliquidacion.valor_moneda_local | currency}}</td>
                                <td>
                                    <span title="imprimir" class="ml-2 btn-imprimir" @click="imprimirPDF(preliquidacion.id)">
                                        <b-icon icon="printer-fill" aria-hidden="true"></b-icon>
                                    </span>
                                </td>
                            </tr>
                            <tr v-if="totales.length > 0">
                                <td colspan="4" class="font-weight-bold text-right">Totales:</td>
                                <td class="font-weight-bold">
                                    ${{totales[0].total | currency}}
                                </td>
                                <td colspan="2" class="font-weight-bold">
                                    ${{totales[0].total_moneda_local | currency}}
                                </td>
                            </tr>
                            <tr v-if="preliquidaciones.length == 0" class="text-center">
                                <td colspan="7">Sin registros</td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-show="cargando" class="text-center app-bkg-color-f5 app-no-data-table b-t" >
                        <Cargando/>
                    </div>
                </div>
                <div v-if="preliquidaciones.length > 0" class="panel-footer">
                    <b-pagination
                    v-model="filtro.paginaActual"
                    :total-rows="totalRegistros"
                    :per-page="filtro.itemsPerPage"
                    aria-controls="my-table"
                    align="right"
                    v-on:input="changePage"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { api } from "@/plugins/api_conect";
import Cargando from '../layouts/Cargando.vue';

export default {
    computed: {
        logueado() {
            return this.$store.getters.loggedIn;
        }
    },
    components: {
      Cargando
    },
    methods: {
        index() {
            api().get(`/api/casillero/estado-cuenta/${this.cliente_id}`,{
                method: "get",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                }
            }).
            then((response) => {
                const { data } = response;
                this.estadosConciliacion = data['datos']['estadosConciliacion'];
                this.destinatarios = data['datos']['destinatarios'];
            }).catch(async (error) => {
                if (error.response && error.response.status === 401) {
                    await this.$auth.refreshToken();
                    this.index();
                }else{
                    let mensaje = this.setErrors(error);
                    this.$swal('Error', mensaje, 'error');
                }
            });
        },
        busqueda() {
            this.filtro.paginaActual = 1;
            this.changePage();
        },
        changePage() {
            this.cargando = true;
            api().post(`/api/casillero/estado-cuenta/busqueda`, this.filtro, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                },
            }).then((response) => {
                const { data } = response;
                this.preliquidaciones = data['datos']['preliquidaciones'].sort((x,y) => y.id - x.id);
                this.totales = data['datos']['totales'];
                this.totalRegistros = data['datos']['total'];
                this.cargando = false;
            }).catch(async (error) => {
                if (error.response && error.response.status === 401) {
                    await this.$auth.refreshToken();
                    this.changePage();
                }else{
                    let mensaje = this.setErrors(error);
                    this.$swal('Error', mensaje, 'error');
                }
            });
            this.cargando = false;

        },
        imprimirPDF(id) {
            this.print = true;
            this.descargarPDF(id);
        },
        descargarPDF(id) {
            api().get(`/api/casillero/despachos/preliquidaciones/impresion-pdf/${id}`, {
                responseType: 'arraybuffer',
                headers: {
                    'Accept': 'application/pdf',
                    Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                }
            })
            .then(response => {
                const blob = new Blob([response.data], {
                    type: 'application/pdf',
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                if (this.print === true) {
                    const w = window.open(url);
                    w.print();
                } else if (this.print === false) {
                    a.href = url;
                    a.download = "solicitudEnvio" + id;
                    document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                    a.click();
                }
                a.remove();
                this.print = false;
            })
            .catch(async (error) => {
                console.error(error);
                if (error.response && error.response.status === 401) {
                    await this.$auth.refreshToken();
                    this.descargarPDF(id);
                } else {
                    await this.$swal("error", 'Error', "error");
                }
            });
        },
        exportarExcel() {
            if (!this.disable_exportar){
                this.titulo_exportar = 'Por favor espere';
                this.disable_exportar = true;
                api().post(`/api/casillero/estado-cuenta/exportar-excel`, this.filtro, {
                    responseType: 'arraybuffer',
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        Authorization: localStorage.getItem('token_type') + " " + localStorage.getItem('access_token')
                    }
                }).then((response) => {
                    const blob = new Blob([response.data], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                    });
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "Estado de cuenta";
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    this.titulo_exportar = 'Exportar Excel';
                    this.disable_exportar = false;
                }).catch(async (error) => {
                    this.titulo_exportar = 'Exportar Excel';
                    this.disable_exportar = false;
                    if (error.response && error.response.status === 401) {
                        await this.$auth.refreshToken();
                        this.exportarExcel();
                    }else{
                        let mensaje = this.setErrors(error);
                        await this.$swal('Error', mensaje, 'error');
                    }
                });
            }
        },
        setErrors(error) {
            let mensaje = "";
            if (error.response.data["errores"]) {
                for (let err in error.response.data["errores"]) {
                    mensaje += "<p>"+error.response.data["errores"][err]+"</p>";
                }
            }
            mensaje = mensaje === "" ? 'Ocurrio un error': mensaje;
            return mensaje
        }
    },
    data(){
        return {
            cliente_id: localStorage.cliente_id,
            estadosConciliacion: [],
            destinatarios: [],
            preliquidaciones: [],
            totalRegistros: 0,
            totales: [],
            titulo_exportar: 'Exportar Excel',
            disable_exportar: false,
            filtro: {
                fecha_desde: "",
                fecha_hasta: "",
                destinatario_id: "",
                estado_conciliacion_id: "",
                busqueda: "",
                itemsPerPage: 10,
                paginaActual:1,
                cliente_id: localStorage.cliente_id
            }
        }
    },
    filters: {
        currency(value) {
            return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        currencyFloat(value) {
            value = parseFloat(value);
            return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        }
    },
    mounted: function() {
        this.index();
        this.changePage();
    }
}
</script>
<style scoped>
.contenido {
    padding: 10px;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
}
.table-color {
    color: black !important;
    background: aliceblue !important;
}
.text-center {
    text-align: center;
}
.pr-38 {
    padding-right: 38px;
}
.btn-outline-dark:hover{
    background: var(--primary-color) !important;
    border-color: #343a40 !important;
    color: #fff !important;
}
.btn-outline-dark:focus, .btn-outline-dark.focus {
    box-shadow: none !important;
}
.btn-imprimir {
    cursor: pointer;
    :hover{
        color: var(--primary-color) !important;
    }
}
@media screen and (max-width: 755px) {
    .input-buscar {
        display: flex !important;
        justify-content: center !important;
        margin-top: 10px !important;
    }
    .row-column {
        margin-top: 10px !important;
    }
}
</style>